import { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const motives = {
  m1: css`
    flex-direction: column;

    input {
      width: 100%;
    }

    label {
      margin-bottom: 1rem;

      color: ${pickColor('grayLabel')};
    }
  `,
  m2: css`
    flex-direction: row;
    align-items: center;

    label {
      margin-bottom: 0;
      min-width: 14rem;
      padding: 1rem 2rem 1rem 0;

      font-size: 1.6rem;

      color: ${pickColor('black')};
      font-family: 'LFT Zeno Condensed';
      text-transform: uppercase;
    }

    input {
      border: 0.1rem solid ${pickColor('borderColorLight')};
      border-radius: ${({ theme }) => theme.borderRadius.base};

      width: 100%;
    }
  `,
  m3: css`
    flex-direction: column;
    gap: 0.6rem;

    label {
      font-size: 1.3rem;
      font-weight: ${({ theme }) => theme.fontWeights.light};

      color: ${pickColor('grayLabel')};
    }

    input {
      width: 100%;

      border: 0.1rem solid ${pickColor('borderColorDarken')};
      border-radius: ${({ theme }) => theme.borderRadius.big};
    }
  `,
  m4: css`
    div {
      margin-left: 0;
    }

    input {
      width: 100%;
      margin-left: 0;

      border: 0.1rem solid ${pickColor('borderColorDarken')};
      border-radius: ${({ theme }) => theme.borderRadius.big};
    }
  `,
  search: css`
    flex-direction: column;

    label {
      color: ${pickColor('black')};

      font-size: 1.2rem;
      font-family: 'LFT Zeno', sans-serif;

      text-transform: capitalize;
    }

    input {
      width: 100%;
      height: 3rem;

      border: 0.1rem solid ${pickColor('black')};
      border-radius: ${({ theme }) => theme.borderRadius.base};

      /* &:hover { */
      /* border: 0.1rem solid #dfe8f2 !important; */
      /* } */

      font-size: 1.2rem;
    }
  `,
  customer: css`
    label {
      height: 1.9rem;
    }

    input {
      width: 100%;
      height: 3.6rem;
      margin-left: 0;

      border: 0.1rem solid ${pickColor('borderColorDark')};
      border-radius: ${({ theme }) => theme.borderRadius.base};
    }
  `,
  login: css`
    flex-direction: column;

    label {
      margin-bottom: 0.4rem;

      font-weight: 700;
      font-family: 'LFT Zeno', sans-serif;
      font-size: 1.2rem;
    }

    input {
      height: 4.6rem;
      padding: 1.4rem 1.9rem;

      border: 0.1rem solid ${pickColor('black')};
      border-radius: ${({ theme }) => theme.borderRadius.base};

      font-size: 1.4rem;
    }
  `,
};

export type InputMotives = keyof typeof motives;

const pickMotive = (motive: InputMotives) => motives[motive];

export { pickMotive };
